import { Star } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { TESTIMONIALS } from "../data/siteData";

function GoogleG({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-label="Google">
      <path fill="#4285F4" d="M23.5 12.27c0-.85-.08-1.66-.22-2.45H12v4.64h6.45a5.52 5.52 0 0 1-2.39 3.62v3h3.87c2.26-2.09 3.57-5.16 3.57-8.81z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.92l-3.87-3c-1.08.72-2.45 1.15-4.06 1.15-3.12 0-5.76-2.11-6.7-4.95H1.29v3.1A12 12 0 0 0 12 24z" />
      <path fill="#FBBC05" d="M5.3 14.28A7.2 7.2 0 0 1 4.92 12c0-.79.14-1.56.38-2.28v-3.1H1.29a12 12 0 0 0 0 10.76l4.01-3.1z" />
      <path fill="#EA4335" d="M12 4.77c1.76 0 3.34.61 4.58 1.8l3.44-3.44A11.98 11.98 0 0 0 12 0 12 12 0 0 0 1.29 6.62l4.01 3.1C6.24 6.88 8.88 4.77 12 4.77z" />
    </svg>
  );
}

export default function Testimonials() {
  return (
    <section className="bg-[#FBF9F5] py-20 lg:py-28" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Eyebrow>Client Words</Eyebrow>
            <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-[#1A2E20] sm:text-4xl">
              What the neighbourhood says
            </h2>
          </div>
          <div className="flex items-center gap-3 border border-[#234E33]/12 bg-[#FAF7F2] px-5 py-3">
            <GoogleG className="h-5 w-5" />
            <span className="text-sm font-semibold text-[#1A2E20]">Google Reviews</span>
            <span className="flex text-[#E29547]">
              {[...Array(5)].map((_, s) => (
                <Star key={s} size={14} fill="currentColor" strokeWidth={0} />
              ))}
            </span>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="flex h-full flex-col border border-[#234E33]/12 bg-[#FAF7F2] p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              >
                <div className="flex items-center justify-between">
                  <span className="flex text-[#E29547]">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} size={14} fill="currentColor" strokeWidth={0} />
                    ))}
                  </span>
                  <GoogleG />
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-[#4a544c]">
                  “{t.text}”
                </blockquote>
                <figcaption className="mt-5 border-t border-[#234E33]/10 pt-4">
                  <p className="text-sm font-bold text-[#1A2E20]">{t.name}</p>
                  <p className="mt-0.5 font-mono-x text-[10px] uppercase tracking-[0.2em] text-[#C86D51]">
                    {t.service} · {t.area}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-8">
          <p className="text-xs text-[#4a544c]/70" data-testid="testimonials-sample-note">
            Sample reviews shown for layout — live Google reviews pull in automatically once the Skloccom Google
            Business profile is connected.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
